export default [
  {
    path: "integrations",
    name: "integrations",
    component: (): Promise<any> => import(/* webpackChunkName: "integrations" */ "@/views/Admin/IntegrationsView.vue")
  }
];
